import { Card, CardContent, MenuItem, Stack, Typography, useTheme } from "@mui/material";
import { useFormContext  } from "react-hook-form";
import { DataFileImportFormType, ItemMapFormType } from "../DataFileImportEditorUtils";
import { IKeyValuePair } from "../../../../common/models/KeyValuePair";
import FormSelect from "../../../../components/forms/form-select/FormSelect";
import { useTranslation } from "react-i18next";
import { getObjectTypeName } from "../../../../common/utilities/GetObjectTypeName";
import { SetPointEventTypeEnum } from "../../../../common/enums/SetPointEventTypeEnum";


export type DataFileImportItemListItemProps = {
    name: 'tagTypeMap' | 'objectMap',
    item: ItemMapFormType,
    pickList: IKeyValuePair<number, string>[]

}

export function DataFileImportItemListItem({
    name,
    item,
    pickList
    
}: DataFileImportItemListItemProps) {

    const { t } = useTranslation();
    const theme = useTheme();
    const {
        getValues,
        watch,
        setValue
    } = useFormContext<DataFileImportFormType>();    
    
    const [
        items,
        importObjectType,
        attributeName
    ] = watch([
        name,
        'importObjectType',
        'attributeName'
    ]);

    // we need the 'real' index of the item
    const index = items.findIndex(o => o.column === item.column);

    const selectedItems = items.filter(o => o.column !== item.column && o.id > -1).map(o => o.id);

    const filteredList = pickList.filter(o => {
        return o.Key === item.id || !selectedItems.find(v => v === o.Key);
    });

    const tagTypeValue = index !== -1 ? items[index].id : -1;
    const enableEventType = tagTypeValue > -1;

    const helperText = name === 'objectMap' && attributeName.length !== 0 && item.id === -1 ?
        t('dataFileImport.selectObjectHelper', {objectType: getObjectTypeName(importObjectType)}):
        undefined;

    function onTagTypeChanged() {
        const val = getValues(`${name}.${index}.id`);
        if (val < 0) {
            setValue(`${name}.${index}.eventType`, SetPointEventTypeEnum.Imported);
        }
    }

    return (
        <Card variant="outlined">
            <CardContent sx={{
                padding: (theme) => `${theme.spacing(2)}!important`,
            }}>
                <Stack direction='row' sx={{
                    justifyContent: 'space-between'
                }}>
                    <Typography
                        variant='body1'
                        sx={{
                            flexBasis: '40%',
                            marginTop: 'auto',
                            marginBottom: 'auto'
                        }}>
                        {item.column}
                    </Typography>

                    <FormSelect
                        name={`${name}.${index}.id`}
                        label={name === 'tagTypeMap' ? t('dataFileImport.tagType') : getObjectTypeName(importObjectType, true) }
                        sx={{ 
                            //width: 1,
                            marginTop: 1,
                            flexBasis: name === 'objectMap' ? '50%' : '25%'
                        }}
                        onChange={() => {onTagTypeChanged();}}
                        helperText={helperText ? <Typography variant='subtitle2' sx={{
                            fontSize: ".75rem",
                            color: theme.palette.error.main
                        }}>{helperText}</Typography> : null}
                    >
                        <MenuItem value={-1} disabled={true}>
                        </MenuItem>

                        <MenuItem value={-2}>
                            {t(name === 'objectMap' ? 'dataFileImport.ignoreIdentifier': 'dataFileImport.ignoreColumn')}
                        </MenuItem>

                        {
                            // pickList.map((o, ndx) => 
                            filteredList.map((o, ndx) => 
                                <MenuItem 
                                    //key={`${item.column}.${o.Key}`} 
                                    key={`${item.column}.${ndx}`}
                                    value={o.Key}>
                                    {o.Value}
                                </MenuItem>
                            )
                        }
                    </FormSelect> 

                    {name === 'tagTypeMap' && 
                    <FormSelect
                        name={`${name}.${index}.eventType`}
                        label='Event Type'
                        disabled={!enableEventType}
                        sx={{ 
                            //width: 1,
                            marginTop: 1,
                            flexBasis: '25%'
                        }}
                    >
                        <MenuItem value={SetPointEventTypeEnum.Imported}>
                            Imported
                        </MenuItem>

                        <MenuItem value={SetPointEventTypeEnum.Manual}>
                            Manual
                        </MenuItem>

                    </FormSelect>    
                    }                 
                </Stack>
               
            </CardContent>
        </Card>
    );
}
